var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    // default styles
    'w-max py-2.5 px-3.5 flex items-baseline rounded-lg mb-2 pointer-events-auto',
    _vm.notificationType === 'success' && {
      'bg-canary-500 hover:bg-canary-400': _vm.darkMode === true,
      'bg-grape-500 hover:bg-grape-600': _vm.darkMode === false || _vm.darkMode === 'auto',
      'bg-grape-500 hover:bg-grape-600 dark:bg-canary-500 dark:hover:bg-canary-400': _vm.darkMode === 'auto',
    },
    // error snackbar styles
    _vm.notificationType === 'error' && {
      'bg-scarlet-600 hover:bg-scarlet-400': _vm.darkMode === true,
      'bg-danger-100 hover:bg-scarlet-400': _vm.darkMode === false || _vm.darkMode === 'auto',
      'bg-danger-100 hover:bg-scarlet-600 dark:bg-scarlet-600 dark:hover:bg-danger-100': _vm.darkMode === 'auto',
    } ]},[(_vm.iconName)?_c('OzIcon',{class:[
      // default styles
      'p-1 me-2 rounded-full',

      // success snackbar styles
      _vm.notificationType === 'success' && {
        'text-dark-text-100 bg-light-text-400': _vm.darkMode === true,
        'text-light-text-100 bg-dark-text-400': _vm.darkMode === false || _vm.darkMode === 'auto',
        'dark:text-dark-text-100 dark:bg-light-text-400': _vm.darkMode === 'auto',
      },

      // error snackbar styles
      _vm.notificationType === 'error' && {
        'text-light-text-100': true,
        'bg-light-text-400': _vm.darkMode === true,
        'bg-dark-text-400': _vm.darkMode === false || _vm.darkMode === 'auto',
        'bg-dark-text-400 dark:bg-light-text-400': _vm.darkMode === 'auto',
      } ],attrs:{"name":_vm.iconName,"size":12}}):_vm._e(),_vm._v(" "),_c('div',[_c('span',{class:[
        // default styles
        'text-body-small-posts',

        // success snackbar styles
        _vm.notificationType === 'success' && {
          'text-dark-text-100': _vm.darkMode === true,
          'text-light-text-100': _vm.darkMode === false || _vm.darkMode === 'auto',
          'text-light-text-100 dark:text-dark-text-100': _vm.darkMode === 'auto',
        },

        // error snackbar styles
        _vm.notificationType === 'error' && 'text-light-text-100' ]},[_vm._v(_vm._s(_vm.message))])]),_vm._v(" "),(_vm.actionText)?_c('OzTextButton',{class:[
      'ms-2 text-body-small-posts font-bold',
      {
        'text-dark-text-200': _vm.darkMode === true,
        'text-light-text-200': _vm.darkMode === false,
        'text-light-text-200 dark:text-dark-text-200': _vm.darkMode === 'auto',
      },
      {
        'hover-hover:hover:text-dark-text-100': _vm.darkMode === true,
        'hover-hover:hover:text-light-text-100': _vm.darkMode === false,
        'hover-hover:hover:text-light-text-100 hover-hover:dark:hover:text-dark-text-100': _vm.darkMode === 'auto',
      } ],attrs:{"text":_vm.actionText,"color-scheme":_vm.OzTextButtonColorScheme.Bare},on:{"click":_vm.actionTextClick}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }